export const opciones = ['Productor', 'Importador', 'Empacador', 'Envasador'];
